import { getFooterNavData } from "../api"
import { toastError, toastWarn } from "../../../errors.toast";
import {
    GET_FOOTERNAV_REQUEST,
    GET_FOOTERNAV_SUCCESS,
    GET_FOOTERNAV_FAILURE,
} from "../const";


const request = () => ({ type: GET_FOOTERNAV_REQUEST});

const success = (menu) => ({
    type: GET_FOOTERNAV_SUCCESS,
    payload: { menu },
});
const failure = () => ({ type: GET_FOOTERNAV_FAILURE});

export const receiveFooterNav = (params) => async (dispatch) => {
    dispatch(request());
    try {
        const { data: receiveFooterNavData } = await getFooterNavData(params).catch((error)=> {
            if (error.response.status === 400) {
                toastWarn(`${error.response.status} Bad request`)
            } else {
                if (error.response.status === 500) {
                    toastError(`${error.response.status} Server error`)
                }
            }})

        dispatch(success(receiveFooterNavData));
    } catch (e) {
        dispatch(failure());
    };
};